// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"link-button-m__wrapper__3tp3U","content":"link-button-m__content__APDeE"};